import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { FormularioCalificacion } from "../../components/EtapasDeCalificacion/FormularioCalificacion";
import { InformacionFuncionario } from "../../components/EtapasDeCalificacion/InformacionFuncionario";
import { PlaceholderColumnas } from "../../components/Otros/Placeholder";
import { InformacionProcesoParticipacion } from "../../components/ProcesosDeCalificacion/InformacionProcesoParticipacion";
import {
  autorizarPrecalificacion,
  cargarDatosProceso,
  cargarProcesoActivo,
} from "../../utils/Datos";

export const AutorizarPrecalificacion = () => {
  const { id_participant, id_precalificacion } = useParams();
  const [datosProceso, setDatosProceso] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);

  const [acepto, setAcepto] = useState(false);

  useEffect(() => {
    setCargandoDatos(true);
    cargarProcesoActivo().then((datos) => {
      cargarDatosProceso(datos.id_process).then((datosProceso) => {
        setDatosProceso(datosProceso);
        setCargandoDatos(false);
      });
    });
  }, []);

  const handleClick = (id_prequalifications) => {
    setCargandoDatos(true);
    autorizarPrecalificacion(id_prequalifications).then((respuesta) => {
      console.log(respuesta);
      if (respuesta.status) {
        Swal.fire({
          title: "Autorizado",
          text: "ok",
          icon: "success",
          confirmButtonText: "Ok",
        }).then((okay) => {
          if (okay) {
            window.location.href = "/administracionMunicipal";
          }
        });
        //Redirect ?
      } else {
        Swal.fire({
          title: "No autorizado",
          text: respuesta.errores ?? "Ocurrió un error",
          icon: "error",
          confirmButtonText: "Ok",
        }).then((okay) => {});
      }
      setCargandoDatos(false);
    });
  };

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <div className="toolbar" id="kt_toolbar">
        <div
          id="kt_toolbar_container"
          className="container-fluid d-flex flex-stack"
        >
          <div
            data-kt-swapper="true"
            data-kt-swapper-mode="prepend"
            data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
            className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
          >
            <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
               Autorizar precalificación
            </h1>
            <span className="h-20px border-gray-300 border-start mx-4" />
            <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
              <li className="breadcrumb-item text-muted">
                <a href="#" className="text-muted text-hover-primary">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-300 w-5px h-2px" />
              </li>
              <li className="breadcrumb-item text-dark">Autorizar</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div className="container-xxl">
          <div className="row gy-5 g-xl-8">
            <div className="col-xl-12 ">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bolder text-dark">
                       INFORMACIÓN DEL PROCESO
                    </span>
                  </h3>
                </div>
                <div className="card-body">
                  {datosProceso == null ? (
                    <PlaceholderColumnas
                      columnas={2}
                      filas={4}
                    ></PlaceholderColumnas>
                  ) : (
                    <InformacionProcesoParticipacion
                      proceso={datosProceso}
                    ></InformacionProcesoParticipacion>
                  )}
                </div>
              </div>
            </div>

            <InformacionFuncionario
              id_participant={id_participant}
            ></InformacionFuncionario>

            <div className="col-xl-12 ">
              <div className="card ">
                <div className="card-header ">
                  <h3 className="card-title align-items-start flex-column ">
                    <span className="card-label fw-bolder text-dark ">
                       Funcionario/a a precalificar
                    </span>
                  </h3>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-8 col-sm-12">
                      <FormularioCalificacion
                        calificacion={id_precalificacion}
                      ></FormularioCalificacion>
                    </div>
                    <div className="col-lg-4 col-sm-12">
                      <div>
                        <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-12 p-6">
                          <span className="svg-icon svg-icon-2tx svg-icon-warning me-4">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <rect
                                opacity="0.3"
                                x={2}
                                y={2}
                                width={20}
                                height={20}
                                rx={10}
                                fill="currentColor"
                              />
                              <rect
                                x={11}
                                y={14}
                                width={7}
                                height={2}
                                rx={1}
                                transform="rotate(-90 11 14)"
                                fill="currentColor"
                              />
                              <rect
                                x={11}
                                y={17}
                                width={2}
                                height={2}
                                rx={1}
                                transform="rotate(-90 11 17)"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                          <div className="d-flex flex-stack flex-grow-1">
                            <div className="fw-bold">
                              <h4 className="text-gray-900 fw-bolder">
                                Declaración
                              </h4>
                              <div className="fs-6 text-gray-700">
                                {`Declaro que me reuniré presencial o virtualmente con el(la) Funcionario(a) para entregar retroalimentación y fundamentación de la evaluación`}
                              </div>
                              <div className="form-check form-check-custom  form-check-success form-check-solid mt-8">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  defaultValue={1}
                                  id="acepto"
                                  checked={true}
                                  onClick={() => {
                                    setAcepto(true);
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="acepto"
                                  checked={true}
                                >
                                  Confirmo la declaración
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <button
                          className="btn btn-sm btn-success btn-block px-6 mt-8 align-self-center text-nowrap"
                          type="button"
                          disabled={cargandoDatos}
                          title={
                            !acepto ? "Primero debe aceptar la declaración" : ""
                          }
                          onClick={() => handleClick(id_precalificacion)}
                        >
                          {cargandoDatos
                            ? " Autorizando..."
                            : " Autorizar"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
